module.exports = __webpack_public_path__ + "static/img/character-girl-2.ee07110.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/characters/character-girl-2.png
// module id = 97bE
// module chunks = 0